import React from 'react'

export function Spinner() {
  const size = 32
  const strokeWidth = 4
  const opacity = 0.2
  const duration = 1
  const stroke = 'var(--highlight-background)'

  const radius = size / 2 - strokeWidth
  const center = radius + strokeWidth
  const circleProps = {
    strokeWidth,
    r: radius,
    cx: radius + strokeWidth,
    cy: radius + strokeWidth,
    fill: 'none',
  }

  return (
    <svg width={size} height={size} stroke={stroke}>
      <circle {...circleProps} style={{ opacity }} />
      <circle {...circleProps} strokeDasharray="20 180">
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          from={`0 ${center} ${center}`}
          to={`360 ${center} ${center}`}
          dur={`${duration}s`}
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  )
}
